// extracted by mini-css-extract-plugin
export default {"loader":"App_loader__SbZCZ","mainContainer":"App_mainContainer__Zrnhn"};